import {
  HubspotServices as Hubspot,
  MarketoServices as Marketo,
  SalesforceServices as Salesforce,
  WebhookServices as Webhook,
} from '@clearkit/icons';

import { AccountFlagEnum } from '~/generated/graphql';
import { useFeatureFlag } from '~/hooks/account';

import { useHasOperationsAccess } from '../../../../hooks/account/usePlatformAccess';
import AddPlanPanel from './AddPlanPanel';

function AddOperationsPlan() {
  const allowWebhookAccesss = useFeatureFlag(
    AccountFlagEnum.AllowPlatformWebhookDestination,
  ).enabled;

  if (useHasOperationsAccess() || allowWebhookAccesss) {
    return null;
  }

  const destinations = [
    {
      name: 'Webhook',
      description: 'Send data anywhere with Webhooks',
      icon: <Webhook className="w-8 h-8" />,
    },
  ];

  return (
    <AddPlanPanel
      description="Get the context you need on every lead, contact and account your company cares about to power precise lead scoring and routing, rich customer segmentation, and reports that drive results."
      destinations={destinations}
      footerDescription="Also, write enriched data directly to your systems like Salesforce, Marketo, and Hubspot"
      footerIcons={[Salesforce, Marketo, Hubspot]}
      title="Accelerate Revenue"
    />
  );
}
export default AddOperationsPlan;
